export enum ViewportSize {
  SMALL_0 = 0,
  EXTRA_LARGE_1200 = 1200,
  EXTRA_LARGE_1440 = 1440,
  EXTRA_EXTRA_LARGE_1600 = 1600,
}
